import React from 'react';
import JuliaPanel from './JuliaPanel';

interface JuliaPanelAsideProps {
  moduleName: string;
  contextMessage: string;
  pendingTasks?: number;
}

const JuliaPanelAside: React.FC<JuliaPanelAsideProps> = (props) => (
  <aside
    aria-label="Assistant Julia"
    className="julia-panel-aside"
    style={{
      flex: '0 0 clamp(280px, 28vw, 340px)',
      width: 'clamp(280px, 28vw, 340px)',
      maxWidth: '100%',
      position: 'sticky',
      top: 'calc(var(--header-height) + 1rem)',
      alignSelf: 'flex-start',
      height: 'calc(100vh - var(--header-height) - 2rem)',
      maxHeight: 'calc(100vh - var(--header-height) - 2rem)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      background: 'var(--julia-panel-gradient)',
      border: '1px solid rgba(14, 165, 233, 0.2)',
      borderRadius: 'var(--radius-2xl)',
      padding: '1rem 1.1rem 1.1rem',
      boxShadow: '0 8px 32px rgba(27, 42, 74, 0.08)',
      boxSizing: 'border-box',
    }}
  >
    <JuliaPanel {...props} />
  </aside>
);

export default JuliaPanelAside;
